import { useMemo } from 'react';

// 替代物料&可能想找&替代参考标签
export default function MaybeLookTag(props) {
  const { mappingCodeSet, maybeLook, productCode } = props;

  const labelText = useMemo(() => {
    if (mappingCodeSet?.includes(productCode?.toLocaleLowerCase())) {
      return '替代物料';
    } else if (maybeLook === 'maybe') {
      return '可能想找';
    } else if (maybeLook === 'replace') {
      return '替代参考';
    } else {
      return '';
    }
  }, [mappingCodeSet, maybeLook, productCode]);

  return (
    labelText && (
      <span
        className="absolute left-[-22px] top-[20px] z-[5] flex h-[80px] w-[22px] items-center rounded-[4px_0_0_4px]
      text-[#fff] text-center leading-[16px] bg-[#0093E6]"
      >
        {labelText}
      </span>
    )
  );
}
